export const formatFullName = (
  firstName?: string,
  lastName?: string,
  title?: string,
  defaultValue: string = ""
): string => {
  const parts = [title, firstName, lastName].filter((i) => !!i)

  return parts.length ? parts.join(" ") : defaultValue
}
